"use client";

import { type ReactNode } from "react";

export interface NumericInputIconProps {
  icon?: ReactNode;
  position: "left" | "right";
}

export const NumericInputIcon: React.FC<NumericInputIconProps> = ({
  icon,
  position,
}) => {
  if (!icon) return null;

  if (position === "left") {
    return <div className="ui:text-xs">{icon}</div>;
  }

  return (
    <div className="ui:relative ui:flex ui:w-12 ui:items-center ui:self-stretch ui:border-l ui:border-divider ui:pr-2 ui:pl-4 ui:text-xs">
      {icon}
    </div>
  );
};
